import moment from "moment";
import React, { useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../components/Firebase";

const NewsDetails = () => {
  let { state } = useLocation();
  let navigate = useNavigate();
  const [news, setNews] = useState(state.item);
  const [title, setTitle] = useState(news.title);
  const [content, setContent] = useState(news.content);
  //console.log(news);
  const Button = styled.button`
    background-color: black;
    color: white;
    font-size: 20px;
    padding: 10px 60px;
    border-radius: 5px;
    margin: 10px 0px;
    cursor: pointer;
  `;
  const onSubmit = () => {
    if (title && content) {
      db.collection("news")
        .doc(news.id)
        .update({
          title: title,
          content: content,
          date: Date.now(),
          id: news.id,
        })
        .then((i) => {
          navigate("/dashboard/news");
          setContent("");
          setTitle("");
        });
    } else {
      return alert("please fill the form");
    }
  };
  const onDelete = () => {
    db.collection("news")
      .doc(news.id)
      .delete()
      .then((i) => {
        navigate("/dashboard/news");
      });
  };
  
  return (
    <div class="col-md-12">
          <div class="form-group">
            <label class="form-control-label">Title:</label>
            <input class="form-control" value={title} onChange={(e) => { setTitle(e.target.value); }} />
          </div>
          <div class="form-group">
            <label class="form-control-label">Content:</label>
            <textarea class="form-control" value={content} onChange={(e) => { setContent(e.target.value);}} multiple></textarea>
          </div>
          <div class="form-group">
            <label class="form-control-label">Created At:</label>
            {moment(news.date).format("D MMM, YYYY")}
          </div>
          
          <button class="btn btn-primary" onClick={onSubmit}>Submit</button> <button class="btn btn-primary" onClick={onDelete}>Delete</button>
      </div>
  );
};

export default NewsDetails;
